module.exports = __webpack_public_path__ + "static/media/LOSS1.5b5a277.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/LOSS1.mp3
// module id = 253
// module chunks = 1 2 3 4